var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{ref:"canvas_interface",staticClass:"absolute overlay canvas canvas--interface"})}
var staticRenderFns = []

export { render, staticRenderFns }